import {IApp} from "@/interfaces/app.interface";
import {IAgentReport} from "@/modules/Report/interfaces/agent-report.interface";
import {bus} from "@/plugins/bus";

export function getHtmlAgentSummary(sum: IAgentReport.IAgentSummary) {
  let text = '';

  text += `
    <div class="summary-block">
  `;
  if (sum.clientSum) {
    text += `
      <div class="summary-item">
        <span class="label">Сумма, полученная от физ. лиц - </span>
        <span class="value">
          ${sum.clientSum ? bus.$options.filters.currency(sum.clientSum, 'руб.') : '0 руб.'}
          ${ sum.nds ? ' в т.ч. НДС ' + sum.nds + '%' : ' без НДС' }
        </span>
      </div>
    `;
  }
  if (sum.corpSum) {
    text += `
      <div class="summary-item">
        <span class="label">Сумма, полученная от юр. лиц - </span>
        <span class="value">
          ${sum.corpSum ? bus.$options.filters.currency(sum.corpSum, 'руб.') : '0 руб.'}
          ${ sum.nds ? ' в т.ч. НДС ' + sum.nds + '%' : ' без НДС' }
        </span>
      </div>
    `;
  }

  text += `
    <div class="summary-item">
          <span class="label">Вознаграждение агента - </span>
          <span class="value">${sum.agent ? bus.$options.filters.currency(sum.agent, 'руб.') : ''}</span>
      </div>
      <div class="summary-item">
          <span class="label">Сумма к перечислению заказчику - </span>
          <span class="value">${sum.customerSum ? bus.$options.filters.currency(sum.customerSum, 'руб.') : ''}</span>
      </div>
    </div>
  `;

  return text;
}

export function PrintAgentReport(agentData: IAgentReport.IAgentPrintDocument, table: IAgentReport.IDataItem[]) {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const mywindow = iframe.contentWindow;

  // let mywindow = window.open('', 'PRINT', 'height=400,width=600');
  mywindow.document.write(`<html><head><title>Отчет агента №5</title><style>
        table {
            width: 100%;
          }
          td {
            padding: 3px 10px;
            vertical-align: top;
          }

          table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
          }

          /* Стили для печати - скрываем колонтитулы */
          @page {
            size: 'portrait';
            margin: 10mm;

            /* Скрываем верхний колонтитул (дата, URL) */
            @top-center {
              content: "";
              display: none;
            }

            /* Скрываем нижний колонтитул (нумерация страниц) */
            @bottom-center {
              content: "";
              display: none;
            }

            @bottom-right {
              content: "";
              display: none;
            }

            @bottom-left {
              content: "";
              display: none;
            }

            /* Альтернативный способ для разных браузеров */
            margin-header: 0;
            margin-footer: 0;
          }

          /* Дополнительные стили для браузеров */
          @media print {
            /* Скрываем URL и дату в верхнем колонтитуле */
            #header, .header, header {
              display: none;
            }

            /* Скрываем нумерацию страниц */
            #footer, .footer, footer {
              display: none;
            }

            /* Убираем лишние отступы */
            body {
              margin: 0;
              padding: 0;
            }
          }

          /* Специфичные правила для WebKit браузеров (Chrome, Safari) */
          @page {
            margin: 2cm;

            /* Для Chrome */
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          /* Для Firefox */
          @-moz-document url-prefix() {
            @page {
              margin: 2cm;
            }
          }

          /* Скрываем пустые строки, которые могут появляться */
          body:after {
            display: none;
          }
          
          /* Глобальные стили для печати и экрана */
        * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }

        body {
            font-family: 'Times New Roman', Times, serif;
            background: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            margin: 5px;
            color: #000000;
        }

        /* Основной контейнер — точная имитация документа для печати */
        .document-container {
            max-width: 800px;
            width: 100%;
            background: white;
            padding: 15px;
            box-shadow: 0 5px 20px rgba(0,0,0,0.1);
            border: 1px solid #e0e0e0;
        }

        /* Заголовки */
        h1, h2, h3 {
            font-weight: normal;
            text-align: center;
            line-height: 1.4;
        }

        .main-title {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
            margin-bottom: 6px;
            text-align: left;
        }

        .sub-title {
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 25px;
        }

        /* Блок со сведениями о сторонах */
        .parties {
            margin: 25px 0 30px 0;
            border: 1px solid #333;
            border-collapse: collapse;
            width: 100%;
            font-size: 15px;
        }

        .parties td, .parties th {
            border: 1px solid #333;
            padding: 10px 14px;
            vertical-align: top;
        }

        .parties td:first-child {
            font-weight: 600;
            width: 35%;
            background-color: #f9f9f9;
        }

        .parties td:last-child {
            width: 65%;
        }

        /* Таблица с данными об оплатах */
        .data-table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0 30px 0;
            font-size: 14.5px;
        }
        .data-table.corp-pays-table {
        margin-top: 10px;
        }

        .data-table th {
            background-color: #f0f0f0;
            font-weight: 600;
            border: 1px solid #333;
            padding: 10px 8px;
            text-align: center;
        }

        .data-table td {
            border: 1px solid #333;
            padding: 8px 10px;
            text-align: center;
        }

        .data-table td:first-child {
            text-align: center;
        }
        
        .data-table.corp-pays-table th:first-child,
        .data-table.corp-pays-table td:first-child {
            text-align: left;
        }

        .data-table td:nth-child(2) {
            text-align: center;
        }

        .data-table td:last-child {
            text-align: right;
            padding-right: 20px;
        }

        /* Итоговые суммы */
        .summary-block {
            margin-top: 35px;
            padding-top: 15px;
        }

        .summary-item {
            font-size: 16px;
        }
        
        .signature-block {
          margin-top: 100px;
          width: 100%;
          text-align: right;
        }
        
        .signature-block__item {
           margin-bottom: 30px;
        }

        /* мелкие правки для печати */
        @media print {
            body {
                margin: 0;
                background: white;
                display: block;
            }
            .document-container {
                max-width: 100%;
                box-shadow: none;
                border: none;
                padding: 0;
            }
            .parties td:first-child {
                background-color: #f9f9f9; /* сохраняем для печати */
            }
            .agent-stamp {
                border: 1px solid #aaa;
                background: #f9f9f9;
            }
            .data-table th {
                background-color: #eaeaea !important;
            }
        }

        /* vue-friendly — простые имена классов, никакой специфики */
        .currency {
            font-family: 'Courier New', monospace;
        }
      </style></head><body>`);

  let tableRows = '';
  table.forEach((row, rowIndex) => {
    tableRows += `
        <tr>
            <td>${row.payDate ? bus.$options.filters.moment(row.payDate, IApp.DateFormats.PrintedDate) : rowIndex === table.length - 1 ? 'ИТОГО' : ''}</td>
            <td>${row.payDate ? bus.$options.filters.moment(row.payDate, 'ddd') : ''}</td>
            <td>${row.cntPays}</td>
            <td>${row.sumPays ? bus.$options.filters.currency(row.sumPays, '') : ''}</td>
        </tr>
    `;
  });

  let corpPays = null;
  if (agentData.corpPays && agentData.corpPays.length) {
    corpPays = `
      <h3 style="text-align: left; font-size: 14px; font-weight: 600; margin: 10px 0 8px 0;">Услуги юридическим лицам:</h3>
      <table class="data-table corp-pays-table">
          <thead>
              <tr>
                  <th>Юридическое наименование</th>
                  <th>Начисления</th>
                  <th>Сумма (руб.)</th>
              </tr>
          </thead>
          <tbody>
    `;
    agentData.corpPays.forEach(corpPay => {
      corpPays += `
        <tr>
            <td>${corpPay.clientName}</td>
            <td>${corpPay.clientCharges ? bus.$options.filters.currency(corpPay.clientCharges, '') : ''}</td>
            <td>${corpPay.clientSum ? bus.$options.filters.currency(corpPay.clientSum, '') : ''}</td>
        </tr>
      `;
    });
    corpPays += `
            </tbody>
        </table>
      `;
  }

  let text = `
    <div class="document-container">
    
      <h1 class="main-title">ОТЧЕТ АГЕНТА № ${agentData.order.agentNumber}</h1>
      <div class="sub-title">
        об исполнении поручения по Договору № ${agentData.order.docNumber} от ${agentData.order.docDate}<br>
        за период с ${agentData.order.period.start} по ${agentData.order.period.end}
      </div>

      <table class="parties">
          <tr><td>Агент (Исполнитель):</td><td>${agentData.agent.name}<br>ИНН ${agentData.agent.inn}, ОГРНИП ${agentData.agent.ogrn}</td></tr>
          <tr><td>Принципал (Заказчик):</td><td>${agentData.client.name}<br>ИНН ${agentData.client.inn}</td></tr>
      </table>

      <h3 style="text-align: left; font-size: 16px; font-weight: 600; margin: 10px 0 8px 0;">2. Содержание отчета:</h3>
      <p style="margin-bottom: 15px; font-size: 15px; text-align: justify;">
          Настоящим Агент подтверждает, что в указанный период во исполнение п. 1.6 Договора № ${agentData.order.docNumber} 
          ${agentData.order.docDate} от имени и за счет Принципала были оказаны следующие услуги третьим лицам 
          (пользователям парковки) и приняты платежи:
      </p>

      <table class="data-table">
          <thead>
              <tr>
                  <th>Дата</th>
                  <th>День недели</th>
                  <th>Количество оплат</th>
                  <th>Сумма (руб.)</th>
              </tr>
          </thead>
          <tbody>
              ${tableRows}
          </tbody>
      </table>
    `;

    if (corpPays) text += corpPays;

    text += getHtmlAgentSummary(agentData.order.sum);

    text += `        
       <div class="signature-block">
          <div class="signature-block__item">Агент: _______________ (Игнатенко В.В.)</div>
          <div class="signature-block__item">Принципал: _______________ (_____________)</div>
        </div>
      </div>
    `;

  mywindow.document.write(text);

  mywindow.document.write('</body></html>');
  mywindow.document.close();
  mywindow.focus();
  mywindow.print();
  mywindow.close();

  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 1000);
}